<template>
<transition name="fade" mode="out-in">
  <div class="page-container">                                                                                                                       
      <div class="content">
        <h1>Sign up</h1>
        <input v-model="firstName" type="text" placeholder="First name" class="fname-input auth-input"><br>
        <input v-model="lastName" type="text" placeholder="Last name" class="lname-input auth-input"><br>
        <input v-model="email" type="text" placeholder="Email address" class="email-input auth-input"><br>
        <!--input v-model="password" type="password" placeholder="Password" class="password-input auth-input"><br-->
        <button class="button auth-button" @click="registerButtonPressed">Signup</button>
      </div>
  </div>
</transition>
</template>

<script>
  //OST-28

  import firebase from "firebase";
  import store from '../store';

  export default {
    data() {
      return {
        email: "",
        firstName: "",
        lastName: ""
      };
    },
    //----------iterate 'registerButtonPressed() over each user. Send in as parameter'
    methods: {
      registerWithLink() {
        var self = this;

        store.commit('updateName', self.firstName, self.lastName);

        var actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for this
          // URL must be whitelisted in the Firebase Console.
          url: 'https://hbrc-18a6e.web.app/dashboard',
          // This must be true.
          handleCodeInApp: true,
          /*iOS: {
            bundleId: 'com.hbrc.ios'
          },
          android: {
            packageName: 'com.hbrc.android',
            installApp: true,
            minimumVersion: '12'
          },
          dynamicLinkDomain: 'hbrc-18a6e.web.app'*/
        };

        firebase.auth().sendSignInLinkToEmail(self.email, actionCodeSettings).then(() => {
          console.log('Link was successfully sent!!!! <alert on page>');
          window.localStorage.setItem('emailForSignIn', self.email);
        }).catch((error) => {
          console.log('login made a woopsie... :', error);
        });
      },
      async registerButtonPressed() {

          //var {user} = await firebase.auth().createUserWithEmailAndPassword(this.email, this.password);
        this.registerWithLink();
          // signout
          /*firebase.auth().signOut().then(user => {
              this.$router.push("/login");
              //console.log("SUCCESS");
              console.log(user);
          });*/

        console.log("END OF REGISTRATION");
      },
      async autoLogin(e, p) {
        try {
          var {
            user
          } = await firebase.auth().signInWithEmailAndPassword(e, p);
        } catch (error) {
          console.log(user);
          console.log(error.message);
        }
        console.log("ROUTING TO PROFILE");
        this.$router.push("/dashboard");
      }
    }
  };
</script>

<style scoped lang="scss">
.page-container {
    background: #f7f7f7;
}

h1 {
  text-align: center;
}

button {
  padding: 8px;
  width: 100%;
}
</style>